// Licensed to Elasticsearch B.V under one or more agreements.
// Elasticsearch B.V licenses this file to you under the Apache 2.0 License.
// See the LICENSE file in the project root for more information
'use strict';

var _classCallCheck = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var BaseConnectionPool = require('./BaseConnectionPool');

var CloudConnectionPool = /*#__PURE__*/function (_BaseConnectionPool) {
  _inherits(CloudConnectionPool, _BaseConnectionPool);

  function CloudConnectionPool() {
    var _this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CloudConnectionPool);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CloudConnectionPool).call(this, opts));
    _this.cloudConnection = null;
    return _this;
  }
  /**
   * Returns the only cloud connection.
   *
   * @returns {object} connection
   */


  _createClass(CloudConnectionPool, [{
    key: "getConnection",
    value: function getConnection() {
      return this.cloudConnection;
    }
    /**
     * Empties the connection pool.
     *
     * @returns {ConnectionPool}
     */

  }, {
    key: "empty",
    value: function empty(callback) {
      var _this2 = this;

      _get(_getPrototypeOf(CloudConnectionPool.prototype), "empty", this).call(this, function () {
        _this2.cloudConnection = null;
        callback();
      });
    }
    /**
     * Update the ConnectionPool with new connections.
     *
     * @param {array} array of connections
     * @returns {ConnectionPool}
     */

  }, {
    key: "update",
    value: function update(connections) {
      _get(_getPrototypeOf(CloudConnectionPool.prototype), "update", this).call(this, connections);

      this.cloudConnection = this.connections[0];
      return this;
    }
  }]);

  return CloudConnectionPool;
}(BaseConnectionPool);

module.exports = CloudConnectionPool;